import { MotifIcon } from '@ey-xd/motif-react'
import WorkspaceStatus from '../atoms/WorkspaceStatus'
import iconSvg from "../../assets/icons/icon.svg.json";

const AdminTrainingsLIstTable = (props: any) => {
    const { tableData } = props;

    return (
        <div className="w-full">
            <table className="w-full text-left ">
                <thead className="bg-[#1A1A24] table-header !sticky top-[-1px]" style={{ zIndex: 1 }}>
                    <tr>
                        <th className="border p-4 border-[#2E2E38]">Document name</th>
                        <th className="border p-4 border-[#2E2E38]">Uploaded on</th>
                        <th className="border p-4 border-[#2E2E38]">Status</th>
                        <th className="border p-4 border-[#2E2E38] text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData?.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center border cursor-default p-4 border-[#2E2E38]">
                                No records found!!!
                            </td>
                        </tr>
                    )}
                    {(tableData ?? []).map((data: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td className="border cursor-default p-4 border-[#2E2E38]">
                                    {data.fileName}
                                </td>
                                <td className="border cursor-default p-4 border-[#2E2E38]">
                                {data.createdDate}
                                </td>
                                <td className="border cursor-default p-4 border-[#2E2E38]">
                                    <WorkspaceStatus status={data.status} />
                                </td>
                                <td className="border cursor-default p-4 border-[#2E2E38]">
                                    <div className="flex gap-4 items-center justify-center w-full">
                                        <MotifIcon onClick={() => {
                                            window.open(data.downloadUrl, "_self");
                                        }} src={iconSvg["download-file-icon"]} className="!w-6 cursor-pointer" title='download-icon' />
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default AdminTrainingsLIstTable